import React, {
    lazy, Suspense
} from 'react';
import LoadingSpinner from 'components/UI/LoadingIndicators/LoadingSpinner';
import { isSSR } from './ssr';

const loadable = (importFunc, { fallback = null } = {
    fallback: (
        <div className="tw-mt-64"><LoadingSpinner loading /></div>
    ),
}) =>
{
    const LazyComponent = lazy(importFunc);

    return props => (
        <Suspense fallback={fallback}>
            <LazyComponent {...props} />
        </Suspense>
    );
};

const basicLoadable = () =>
{
    return () => <div />;
};

export default isSSR() ? basicLoadable : loadable;
